import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const listHolidays = (jurisdiction, year) => {
  const queryParam = {
    jurisdiction: jurisdiction,
    year: year,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${PAYMENT_API}/payment/holiday?${query}`;
  return backend.get(url);
};

const addHoliday = ({date, name, jurisdiction}) => {
  const url = `${PAYMENT_API}/payment/holiday`;
  return backend.post(url, {date, name, jurisdiction});
};

const deleteHoliday = (date, jurisdiction) => {
  const queryParam = {
    jurisdiction: jurisdiction,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  const url = `${PAYMENT_API}/payment/holiday/${date}?${query}`;
  return backend.delete(url);
};

export default {
  listHolidays,
  addHoliday,
  deleteHoliday,
};
